<template>
  <router-view />
</template>

<script>
export default {
  name: "InstrumentInstanceSingle"
};
</script>